import HeroSection from "../components/HeroSection";
import TripTemplates from "../components/TripTemplates";
import HowItWorks from "../components/HowItWorks";
// ... existing code ...
const Index = () => (
  <div className="flex flex-col min-h-screen w-full bg-background text-foreground">
    <HeroSection />
    <TripTemplates />
    <HowItWorks />
  </div>
);
// ... existing code ...
export default Index;